<p-dialog [(visible)]="visible" (onHide)="close()"></p-dialog>
